<template>
  <v-card tile>
    <v-card-title>Zaposleni</v-card-title>
    <v-card-text v-if="employees">
      <v-row>
        <v-col>
          <v-text-field
              v-model="search"
              @change="updateFilters"
              append-icon="mdi-magnify"
              label="Iskalnik"
              single-line
              hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-end" align-self="center">
          <v-btn color="primary" dark @click="create">Dodaj</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-autocomplete
              v-model="filters.company_id"
              :items="companies"
              :search-input.sync="companySearch"
              @change="updateFilters"
              cache-items
              item-text="title"
              item-value="id"
              label="Podjetje"
              clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-autocomplete
              v-model="filters.employee_work_type_id"
              :items="workTypes"
              :search-input.sync="workTypeSearch"
              @click="loadEmployeeWorkTypes"
              @change="updateFilters"
              item-text="name"
              item-value="id"
              label="Tip dela"
              clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-autocomplete
              v-model="filters.employee_status_id"
              :items="statuses"
              :search-input.sync="statusSearch"
              @click="loadEmployeeStatuses"
              @change="updateFilters"
              item-text="name"
              item-value="id"
              label="Status"
              clearable
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-data-table
          :headers="headers"
          :items="employees.data"
          :page.sync="employees.current_page"
          :items-per-page="employees.per_page"
          :server-items-length="employees.total"
          :options.sync="tableOptions"
          :search="search"
          :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }"
          sort-by="id"
          class="elevation-1"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <TooltipIconButton
              tooltip="Uredi"
              icon="mdi-pencil"
              @click="$router.push({ name: 'Employee', params: { id: item.id } })"
          ></TooltipIconButton>
          <TooltipIconButton
              tooltip="Dokumenti"
              icon="mdi-file-document"
              @click="
              $router.push({
                name: 'EmployeeDocuments',
                params: { employeeId: item.id },
              })
            "
          ></TooltipIconButton>
          <TooltipIconButton
              tooltip="Denar"
              icon="mdi-currency-eur"
              @click="
              $router.push({
                name: 'EmployeeMoney',
                params: { employeeId: item.id },
              })
            "
          ></TooltipIconButton>
          <TooltipIconButton
              tooltip="Aktivnost"
              icon="mdi-archive"
              @click="
              $router.push({
                name: 'EmployeeActivity',
                params: { employeeId: item.id },
              })
            "
          ></TooltipIconButton>
          <TooltipIconButton
              tooltip="Izbriši"
              icon="mdi-delete"
              @click="remove(item)"
          ></TooltipIconButton>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="loadEmployees">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import TooltipIconButton from "@/components/TooltipIconButton.vue";

export default {
  data: () => ({
    dialog: false,
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      {text: "Ime", value: "first_name"},
      {text: "Priimek", value: "last_name"},
      {text: "", value: "actions", sortable: false},
    ],
    employees: null,
    editedIndex: -1,
    editedItem: {},
    search: "",

    companies: [],
    companySearch: "",
    workTypes: [],
    workTypeSearch: "",
    statuses: [],
    statusSearch: "",
    filters: {
      company_id: null,
      employee_work_type_id: null,
      employee_status_id: null,
    },
  }),
  mounted() {
    this.search = this.$route.query.search || "";
    if (this.$route.query.company_id) {
      this.loadCompanies(this.$route.query.company_id);
      this.filters.company_id = parseInt(this.$route.query.company_id);
    }
    if (this.$route.query.employee_work_type_id) {
      this.loadEmployeeWorkTypes();
      this.filters.employee_work_type_id = parseInt(this.$route.query.employee_work_type_id);
    }
    if (this.$route.query.employee_status_id) {
      this.loadEmployeeStatuses();
      this.filters.employee_status_id = parseInt(this.$route.query.employee_status_id);
    }
  },
  methods: {
    loadEmployees() {
      let orderBy = {};
      if (
          this.tableOptions.sortBy.length > 0 &&
          this.tableOptions.sortDesc.length > 0
      ) {
        orderBy[this.tableOptions.sortBy[0]] =
            this.tableOptions.sortDesc[0] === true ? "desc" : "asc";
      }
      let params = {
        page: this.tableOptions.page,
        perPage: this.tableOptions.itemsPerPage,
        filters: {},
        orderBy,
      };

      if (this.$route.query.company_id !== null) {
        params.filters["company_id"] = this.$route.query.company_id;
      }

      if (this.$route.query.employee_work_type_id !== null) {
        params.filters["employee_work_type_id"] =
            this.$route.query.employee_work_type_id;
      }

      if (this.$route.query.employee_status_id !== null) {
        params.filters["employee_status_id"] =
            this.$route.query.employee_status_id;
      }

      if (this.$route.query.search !== "") {
        params["search"] = this.$route.query.search;
      }

      this.$http.get("api/v1/employees", {params}).then((response) => {
        this.employees = response.data;
      });
    },
    create() {
      this.$swal({
        title: "Dodaj zaposlenega",
        confirmButtonText: "Dodaj",
        cancelButtonText: "Prekliči",
        showCancelButton: true,
        html:
            'Ime: <input id="swal-input1" class="swal2-input">' +
            'Priimek: <input id="swal-input2" class="swal2-input">',
        focusConfirm: false,
        preConfirm: () => {
          return [
            document.getElementById("swal-input1").value,
            document.getElementById("swal-input2").value,
          ];
        },
      }).then((value) => {
        if (!value.value || value.value.length < 2) {
          return;
        }
        this.$http
            .post("api/v1/employees", {
              first_name: value.value[0],
              last_name: value.value[1],
            })
            .then((response) => {
              this.$router.push({
                name: "Employee",
                params: {id: response.data.id},
              });
            });
      });
    },
    loadCompanies(id = null) {
      let params = {};
      if (this.companySearch) {
        params["filters"] = {title: encodeURI("%" + this.companySearch + "%")};
      }
      if (id !== null) {
        params["filters"] = {id};
      }
      this.$http
          .get("api/v1/companies", {
            params
          })
          .then((response) => {
            this.companies = response.data.data;
          });
    },
    loadEmployeeWorkTypes() {
      if (this.workTypes.length > 1) {
        return;
      }
      this.$http.get("api/v1/employee-work-types").then((response) => {
        this.workTypes = response.data;
      });
    },
    loadEmployeeStatuses() {
      if (this.statuses.length > 1) {
        return;
      }
      this.$http.get("api/v1/employee-statuses").then((response) => {
        this.statuses = response.data;
      });
    },
    remove(item) {
      this.$swal({
        title: "Pozor",
        text: "Ali ste prepričani da želite izbrisati podjetje " + item.title,
        type: "warning",
        confirmButtonText: "Izbriši",
        cancelButtonText: "Prekliči",
        showCancelButton: true,
      }).then((value) => {
        if (value.value !== true) {
          return;
        }
        this.$http.delete("api/v1/employees/" + item.id).then(() => {
          this.loadEmployees();
        });
      });
    },
    updateFilters() {
      let query = {...this.$route.query};
      query['page'] = 1;

      delete query['search'];
      if (this.search.length > 0) {
        query['search'] = this.search;
      }
      delete query['company_id'];
      if (this.filters.company_id !== null) {
        query['company_id'] = this.filters.company_id;
      }
      delete query['employee_work_type_id'];
      if (this.filters.employee_work_type_id !== null) {
        query['employee_work_type_id'] = this.filters.employee_work_type_id;
      }
      delete query['employee_status_id'];
      if (this.filters.employee_status_id !== null) {
        query['employee_status_id'] = this.filters.employee_status_id;
      }

      this.$router.replace({
        query,
      }).catch(() => {
      });
      this.loadEmployees();
    }
  },
  computed: {
    tableOptions: {
      get() {
        return {
          page: parseInt(this.$route.query.page) || 1,
          itemsPerPage: parseInt(this.$route.query.perPage) || 10,
          sortBy: this.$route.query.sortBy ? [this.$route.query.sortBy] : [],
          sortDesc: [this.$route.query.sortDesc === 'true'],
        }
      },
      set(value) {
        let query = {
          page: value.page,
          perPage: value.itemsPerPage,
        };

        if (this.$route.query.search) {
          query["search"] = this.$route.query.search;
        }
        if (this.$route.query.company_id !== null) {
          query['company_id'] = this.$route.query.company_id;
        }
        if (this.$route.query.employee_work_type_id !== null) {
          query['employee_work_type_id'] = this.$route.query.employee_work_type_id;
        }
        if (this.$route.query.employee_status_id !== null) {
          query['employee_status_id'] = this.$route.query.employee_status_id;
        }

        if (value.sortBy.length > 0) {
          query.sortBy = value.sortBy[0];
          query.sortDesc = value.sortDesc[0];
        }
        this.$router.replace({
          query,
        }).catch(() => {
        });
      },
    },
  },
  watch: {
    tableOptions: {
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
          return;
        }
        this.loadEmployees();
      },
      deep: true,
      immediate: true,
    },
    companySearch() {
      this.loadCompanies();
    },
  },
  components: {
    TooltipIconButton,
  },
};
</script>
<style></style>
